import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa'; // Added FaClock
import './contact.css'; 

const ContactSection = () => {
    
    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for your message! We will get back to you shortly.');
        // Add actual form submission logic here
    };

    return (
        <section className="contact-section">
            <div className="container contact-container">
                
                <h2 className="contact-heading">
                    Get  <span className="highlight-green"> in Touch</span>
                </h2>
                <p className="contact-subtitle">
                    Whether you have questions about our loans or need support, our team is ready to help.
                </p>

                <div className="contact-grid">
                    
                    {/* --- 1. Contact Form --- */}
                    <div className="contact-form-wrapper">
                        <h3 className="form-title">Send Us a Message</h3>
                        <form onSubmit={handleSubmit} className="contact-form">
                            
                            <input type="text" placeholder="Your Name" required className="form-input" />
                            <input type="email" placeholder="Your Email" required className="form-input" />
                            <input type="tel" placeholder="Your Phone Number" className="form-input" />
                            
                            <textarea placeholder="Your Message or Query" rows="4" required className="form-textarea"></textarea>
                            
                            <button type="submit" className="submit-button">
                                Send Inquiry
                            </button>
                        </form>
                    </div>

                    {/* --- 2. Map & Details Wrapper (Stacked) --- */}
                    <div className="map-details-wrapper">
                        
                        {/* Live Map Embed */}
                        <iframe 
                            title="Our Location"
                            src="https://maps.google.com/maps?q=Office%20no.%20304%2C%20Laxman%20Palace%2C%20Delhi&t=&z=15&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="450" 
                            frameBorder="0"
                            style={{ border: 0 }}
                            allowFullScreen
                            aria-hidden="false"
                            tabIndex="0"
                            className="map-iframe"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>

                        {/* Contact Details */}
                        <div className="contact-details">
                            <h3 className="details-title highlight-magenta">Contact Details</h3>
                            
                            <div className="info-item">
                                <FaMapMarkerAlt className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Corporate Address:</p>
                                    <p className="info-value">Office no. 304, Laxman Palace, Delhi</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <FaPhone className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Call Us:</p>
                                    <p className="info-value">+91-9205959320</p>
                                </div>
                            </div>
                            
                            {/* 🌟 NEW: Office Hours Item */}
                            <div className="info-item">
                                <FaClock className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Office Hours:</p>
                                    <p className="info-value">10:00 AM - 7:00 PM (Mon-Sat)</p>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <FaEnvelope className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Email Support:</p>
                                    <p className="info-value">info@loanonsalary.com</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ContactSection;